<script lang="ts">
	import { onMount } from 'svelte';
	import { browser } from '$app/environment';

	let scrollY = 0;
	let mobileMenuOpen = false;
	let isScrolled = false;

	$: isScrolled = scrollY > 50;

	onMount(() => {
        console.log("Hello");
		if (browser) {
			const handleScroll = () => {
				scrollY = window.scrollY;
			};
			window.addEventListener('scroll', handleScroll);
			return () => window.removeEventListener('scroll', handleScroll);
		}
	});

	function toggleMobileMenu() {
		mobileMenuOpen = !mobileMenuOpen;
	}

	function closeMobileMenu() {
		mobileMenuOpen = false;
	}

	const navItems = [
		{ href: '/#coponukam', label: 'Čo ponúkam' },
		{ href: '/#akopracujem', label: 'Ako pracujem' },
		{ href: '/#cennik', label: 'Cenník' },
		{ href: '/#kontakt', label: 'Kontakt' }
	];

	function scrollToSection(event: Event, href: string) {
		event.preventDefault();
		const hashIndex = href.indexOf('#');
		const targetId = hashIndex !== -1 ? href.substring(hashIndex + 1) : '';
		const element = document.getElementById(targetId);

		if (element) {
			// We're on the same page, just scroll
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
			closeMobileMenu();
		} else {
			// Navigate to the homepage with the hash
			window.location.href = href;
		}
	}
</script>

<svelte:window bind:scrollY />

<nav class="fixed top-0 left-0 right-0 z-50 transition-all duration-300 shadow-md backdrop-blur-md {isScrolled ? 'py-2' : 'py-4'}" style="background-color: rgba(139, 111, 71, 0.6);">
	<div class="container mx-auto px-4">
		<!-- Desktop Navigation -->
		<div class="hidden md:flex items-center justify-between">
			<div class="logo-text flex items-center">
				<a href="/" class="flex items-center space-x-2">
					<img src="photos/logo.png" alt="Logo" class="{isScrolled ? 'h-10' : 'h-16'} w-auto  transition-all duration-300" />
                    <div class="flex flex-col">
                        <span class="logo-text logo-color font-bold transition-all duration-300 {isScrolled ? 'text-lg' : 'text-3xl'}" >
                            Andrea Vrábeľová
                        </span>
                        <span class="logo-color text-l transition-all duration-300  {isScrolled ? 'text-sm' : 'text-lg'}">
                            Psychologička
                        </span>
                    </div>
				</a>
			</div>
			
			<div class="flex items-center space-x-8">
				{#each navItems as item}
					<a 
						href={item.href} 
						on:click={(e) => scrollToSection(e, item.href)}
						class="transition-colors logo-color duration-200 font-light {isScrolled ? 'text-sm' : 'text-base'} cursor-pointer"
					>
						{item.label}
					</a>
				{/each}
			</div>
		</div>

		<!-- Mobile Navigation Banner -->
		<div class="md:hidden flex items-center justify-between">
			<div class="flex items-center">
				<a href="/" class="flex items-center space-x-2">
					<img src="photos/logo.png" alt="Logo" class="h-12 w-auto" />
                    <div class="flex flex-col">
                        <span class="logo-text logo-color text-xl font-bold transition-all duration-300 {isScrolled ? 'text-lg' : 'text-2xl'}" >
                            Andrea Vrábeľová
                        </span>
                        <span class="logo-color text-sm transition-all duration-300">
                            Psychologička
                        </span>
                    </div>
				</a>
			</div>
			
			<button 
				on:click={toggleMobileMenu}
				class="p-2 logo-color font-light rounded-md hover:bg-gray-100 transition-colors duration-200"
				aria-label="Toggle mobile menu"
			>
				<svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					{#if mobileMenuOpen}
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
					{:else}
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
					{/if}
				</svg>
			</button>
		</div>

		<!-- Mobile Menu Dropdown -->
		{#if mobileMenuOpen}
			<div class="md:hidden mt-4 pb-4 border-t border-gray-200">
				<div class="flex flex-col space-y-3 pt-4">
					{#each navItems as item}
						<a 
							href={item.href} 
							on:click={(e) => scrollToSection(e, item.href)}
							class="transition-colors logo-color font-light duration-200 py-2 px-2 rounded-md hover:bg-gray-100 cursor-pointer"
						>
							{item.label}
						</a>
					{/each}
				</div>
			</div>
		{/if}
	</div>
</nav>

